import { Body, SectionHeader } from "@sprout/typography";
import LocationIcon from "@sprout/icons/location";
import type { ProfileData } from "@/queries/use_profile";

type Props = {
  profile: ProfileData;
};

const ProfileHeader = ({ profile }: Props) => {
  const { email, firstName, lastName, preferredName, location } = profile;
  const givenName = preferredName?.trim() || firstName?.trim();
  const displayName = givenName ? [givenName, lastName?.trim()].filter(Boolean).join(" ") : email;

  return (
    <div className="flex flex-col gap-1">
      <SectionHeader serif as="h2" className="pt-0! text-[38px]! leading-10!">
        {displayName}
      </SectionHeader>
      {location?.display_name && (
        <div className="flex items-center gap-1">
          <LocationIcon size="xs" ariaHidden />
          <Body>{location.display_name}</Body>
        </div>
      )}
    </div>
  );
};

export default ProfileHeader;
